<script>
    export default {
        props: {
            query: String,
            text: String
        },
        computed: {
            getHtml() {
                if (this.query) {
                    const escapedQuery = (this.query || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    const regex = new RegExp(escapedQuery, 'gi');
                    return this.text?.replace(regex, match => `<mark>${match}</mark>`) || '';
                }

                return this.text;
            }
        }
    };
</script>

<template>
    <span v-html="getHtml"></span>
</template>
